import { Input } from '@/components/ui/input'
import { formatPhoneForDisplay } from '@/utils/phone'

export function PhoneInput({
  id,
  value,
  onChange,
  hasError,
  disabled,
  placeholder = 'Enter phone number',
}: {
  id?: string
  value: string
  onChange: (formatted: string) => void
  hasError?: boolean
  disabled?: boolean
  placeholder?: string
}) {
  return (
    <div className="space-y-1">
      <Input
        id={id}
        value={value}
        onChange={(e) => onChange(formatPhoneForDisplay(e.target.value))}
        placeholder={placeholder}
        className={hasError ? 'border-destructive' : ''}
        disabled={disabled}
      />
      <div className="text-xs text-muted-foreground">
        US format by default, or include country code (e.g. +44)
      </div>
    </div>
  )
}
